module.exports = "ckeditor {\n  display: block;\n  height: 300px !important; }\n"